module.exports = __webpack_public_path__ + "media/images/interview_intelligence_sidekick-c7430a47641cb9df92141f9c3ee29960.svg";